export default __webpack_public_path__ + "static/media/FileGroup.d99260a8.svg";